// @flow
import React, {PureComponent} from 'react';
import {View, StyleSheet, Image} from 'react-native';
import {EmphasizedSubText} from 'trpc-react-native-ui';
import {SecondaryFullButton, TertiaryFullButton} from '../common/index';
import theme from '../../theme-config';
import {ResultPage} from '../common/ResultPage';

export default class SuccessPage extends PureComponent<Props> {
  _computeTitle = errorTitle => {
    if (errorTitle && errorTitle !== undefined) {
      return errorTitle;
    } else if (this.props.eSimSelected) {
      return this.props.successEsimTitle;
    } else {
      return this.props.successTitle;
    }
  };

  _computeImage = () =>
    this.props.eSimSelected ? theme.welcomeEsimImage : this.props.successImage;

  styles = getStyles();
  render() {
    const {title, text} = this.props.error || {};

    const ResultContent = (
      <>
        <Image
          style={this.styles.image}
          source={
            this.props.error ? theme.failurePhoneImage : this._computeImage()
          }
          resizeMode="contain"
        />
        <View style={this.styles.textContainer}>
          <EmphasizedSubText
            style={this.styles.title}
            text={this._computeTitle(title)}
            emphStyle={this.styles.boldText}
          />
          {text && (
            <EmphasizedSubText
              style={this.styles.text}
              text={text}
              emphStyle={this.styles.boldText}
            />
          )}
        </View>
      </>
    );
    return (
      <ResultPage
        testID={this.props.pageTestID}
        hasError={this.props.error}
        handleButtonPress={
          !this.props.error && this.props.eSimSelected
            ? this.props.installESimAction
            : this.props.confirmButtonAction
        }
        buttonText={
          !this.props.error && this.props.eSimSelected
            ? this.props.installEsimButtonText
            : this.props.confirmButtonText
        }
        resultContent={ResultContent}
        eSimSelected={this.props.eSimSelected}
        actionType={this.props.actionType}>
        {this.props.actionType == 'suspendLine' &&
          !this.props.eSimSelected &&
          !this.props.error && (
            <>
              <TertiaryFullButton
                style={this.styles.tertiaryButton}
                onPress={this.props.confirmButtonAction}
                text={this.props.confirmButtonText}
                isLoading={this.props.isInitializingSignUp}
              />
            </>
          )}

        {this.props.eSimSelected && !this.props.error && (
          <>
            <TertiaryFullButton
              style={this.styles.tertiaryButton}
              onPress={this.props.confirmButtonAction}
              text={this.props.confirmButtonText}
              isLoading={this.props.isInitializingSignUp}
            />
          </>
        )}
      </ResultPage>
    );
  }
}
type Props = StateProps & DispatchProps;

export type StateProps = {
  confirmButtonText?: string,
  error?: ?Object,
  isInitializingSignUp?: boolean,
  secondaryButtonText?: string,
  successImage?: ?number,
  successTitle?: ?string,
  withGradient?: boolean,
  eSimSelected: boolean,
  successEsimTitle?: string,
};

export type DispatchProps = {
  confirmButtonAction?: Function,
  onSecondaryButtonPress?: Function,
  installESimAction?: Function,
};

function getStyles() {
  return StyleSheet.create({
    title: {
      fontSize: 16,
      textAlign: 'center',
    },
    text: {
      marginTop: 20,
      fontSize: 16,
      textAlign: 'center',
    },
    textContainer: {
      marginBottom: 20,
      paddingHorizontal: 20,
      alignItems: 'center',
    },
    image: {
      height: 200,
      width: 150,
      marginTop: 30,
      marginBottom: 25,
      marginLeft: 10,
    },
    secondaryButton: {
      marginHorizontal: 20,
      marginBottom: 15,
      fontSize: 18,
    },
    tertiaryButton: {
      marginHorizontal: 20,
      marginBottom: 15,
    },
    orderEsimButton: {
      marginHorizontal: 20,
    },
    boldText: {
      fontWeight: 'bold',
      textAlign: 'center',
    },
  });
}
